export class LoginModel {
    login: string;
    email: string;
    senha: string;
    lembreMe: Boolean;
}



// WEBPACK FOOTER //
// ./src/app/routes/login/login.model.ts